<div class="modal__header">
	<div class="modal__header-actions header-actions--mobile">
		<button aria-label="'bookingSearch.aria.closeDialog' | ibeadmin | async" (click)="closeModal()">
			<app-svg svg="icons.svg#general--arrow--left-no_margin" aria-hidden="true" [alt]="'bookingSearch.alt.arrowLeftIcon' | ibeadmin | async"></app-svg>
		</button>
	</div>
	<div class="title_wrapper">
		<h2 class="title" id="modal__title">{{ 'bookingSearch.title.addPassengers' | ibeadmin | async }}</h2>
	</div>
	<div class="modal__header-actions header-actions">
		<button aria-label="'bookingSearch.aria.closeDialog' | ibeadmin | async" (click)="closeModal()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'bookingSearch.alt.closeIcon' | ibeadmin | async"></app-svg>
		</button>
	</div>
</div>

<div class="modal__body select-themes-body sl--scrollable">
	<!-- <app-passenger-dropdown [group]="passengers"></app-passenger-dropdown> -->
	<div class="passengers passengers--modal" [formGroup]="group">
		<ng-container *ngFor="let passenger of passengers">
			<app-counter-input *ngIf="INDRA_canShow(passenger.code)" 
				[formControlName]="passenger.type" 
				[passengerType]="passenger.type"
				[min]=passenger.min 
				[max]=INDRA_passengersMax(passenger.type) 
				[label]="INDRA_getTextTranslation(passenger.label)" 
				[description]="INDRA_getTextTranslation(passenger.description)" 
				[setIncrementToDisable]="setIncrementToDisable" 
				[setDecrementToDisable]="setDecrementToDisable"
				(valueIncrement)="INDRA_handleIncrement($event)" 
				(valueDecrement)="INDRA_handleDecrement($event)">
			</app-counter-input>
		</ng-container>
	</div>

	<div class="passengers__group-info" *ngIf="INDRA_passengersTotal() > 7">
		<span class="description">{{ 'bookingSearch.text.addPassengers' | ibeadmin | async }}</span>
		<a href="javascript:;" class="link link--external" (click)="INDRA_openUrl('externalURLs.bookAGroup');">{{ 'bookingSearch.text.bookAGroup' | ibeadmin | async }}</a>
	</div>
</div>
<div class="modal__footer">
	<div class="modal__footer-action positive-action">
		<button class="button button--small button-accent" (click)="closeModal()">{{ 'bookingSearch.label.submit' | ibeadmin | async }}</button>
	</div>
</div>